<template>
  <div>
    <v-sheet>
      <base-grid
        :badgeColors="badgeColors"
        :ids="badgeIds"
        :items="items"
        :imageUrls="imageUrls"
        gridId="js-learning-item-grid"
        v-on:grid:badge:click="
          $router.push({
            name: 'learningItemManager',
            params: { id: $event.id },
            query: { edit: true }
          })
        "
      >
      </base-grid>
    </v-sheet>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import BaseBadge from "@/components/BaseBadge"
import BaseGrid from "@/components/BaseGrid"

export default {
  mixins: [titleMixin],
  components: { BaseBadge, BaseGrid },
  data: function() {
    return {
      title: "Learning Item Templates"
    }
  },
  created() {
    this.$store.dispatch("learningItems/loadLearningItems")
  },
  computed: {
    items() {
      let items = this.$store.getters["learningItems/getTemplates"]
      let sortedItems = [...items]
      sortedItems.sort((a, b) => {
        const compA = a.name.toUpperCase()
        const compB = b.name.toUpperCase()

        let comparison = 0
        if (compA > compB) {
          comparison = 1
        } else if (compA < compB) {
          comparison = -1
        }
        return comparison
      })

      return sortedItems
    },
    badgeIds() {
      return this.items.map((el, index) => `js-learning-item-grid-${index + 1}`)
    },
    imageUrls() {
      return this.items.map(el => el.badge_url)
    },
    badgeIcons() {
      return Array(this.items.length).fill("mdi-close")
    },
    badgeColors() {
      return Array(this.items.length).fill("red")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
